import PropTypes from 'prop-types';
import React from 'react';
import { useInView } from 'react-intersection-observer';
import PortableText from '../../components/portableText';

function ServicesHome(props) {
    const { ref, inView } = useInView({
        triggerOnce: true,
        threshold: 0.35
    });

    return(
        <section
            ref={ref}
            className={`services--home ${inView ? 'in-view' : ''}`}
        >
            <div className='site-wide grid-container grid-container--4-2 grid-container--reverse'>

              <div className='grid-column copy'>
                {props.content._rawIntro && <PortableText blocks={props.content._rawIntro} />}
              </div>

              <div className='grid-column services'>

                <div className='grid-container'>

                  <div className='grid-column'>
                    {props.content._rawServices1 && <PortableText blocks={props.content._rawServices1} />}
                  </div>
                  <div className='grid-column'>
                    {props.content._rawServices2 && <PortableText blocks={props.content._rawServices2} />}
                  </div>
                  <div className='grid-column'>
                    {props.content._rawServices3 && <PortableText blocks={props.content._rawServices3} />}
                  </div>

                </div>

              </div>

            </div>
          </section>
    );
}

ServicesHome.propTypes = {
    nodes: PropTypes.array,
    content: PropTypes.object
};
  
export default ServicesHome;
  